import { element } from 'angular';
import { createFocusTrap } from 'focus-trap';

import util from './util';
import appTemplate from './app.html';
import aboutTemplate from './templates/about.html';
import infoSheetTemplate from './templates/info-sheet.html';
import searchResultsSheetTemplate from './articles/templates/search-results-sheet.html';
import articleSheetTemplate from './articles/templates/article-sheet.html';

class AppController {
    advancedSearchPanel;
    articles;
    csrfToken;
    hosts;
    user;
    isWelcomeActive;
    isLeftNavActive;
    isFilterActive;
    isDetailPanelActive;
    isKiosk;
    focusTrap: any = null;

    currentYear = new Date().getFullYear();

    static $inject = [
        '$window', '$scope', '$cookies', '$http', '$location', '$route', '$timeout',
        '$mdBottomSheet', '$mdDialog', '$mdMedia', '$mdSidenav', 'appConfig', 'notifier',
        'articleFetchService', 'articleSearchService', 'map'];

    constructor(private $window, private $scope, private $cookies, private $http,
        private $location, private $route, private $timeout, private $mdBottomSheet,
        private $mdDialog, private $mdMedia, private $mdSidenav, private appConfig,
        private notifier, private fetchService, private searchService, private map) {
        this.advancedSearchPanel = element(document.getElementById('advanced-search-filters'));

        this.csrfToken = $cookies.get('csrftoken');
        this.hosts = appConfig.hosts;
        this.user = appConfig.user;
        this.isKiosk = false;

        //Menu
        this.isWelcomeActive = false;
        this.isLeftNavActive = false;
        this.isFilterActive = false;
        this.isDetailPanelActive = false;

        /* Event handlers */
        $scope.$on('$routeChangeStart', () => {
            if ($location.path() === '/') {
                this.reset();
                // HACK: When returning to the Wayfinder home page, wait
                // until the view element is gone then update the map's
                // position.
                const updateMapPosition = () => {
                    const view = document.getElementById('view');
                    if (view) {
                        $timeout(updateMapPosition, 50);
                    } else {
                        this.updateMapPosition();
                    }
                };
                updateMapPosition();
                this.isWelcomeActive = true;
            } else {
                fetchService.article = null;
                this.closeAdvancedSearch();
                $mdBottomSheet.cancel();
                this.closeWelcomePanel();
            }

        });

        $scope.$on('$routeChangeSuccess', () => {
            if ($window.googleAnalytics) {
                $window.googleAnalytics('send', 'pageview', { page: $location.url() });
            } else {
                console.debug('Google Analytics not enabled; not sending pageview event');
            }

            if ($location.path() === '/') {
                if (document.getElementById('view')) {
                    this.$mdSidenav('view').close();
                    this.isDetailPanelActive = false;
                }
                this.$mdSidenav('welcome').open();
                this.isWelcomeActive = true;
            } else {
                if (!document.getElementById('view')) {
                    this.$mdSidenav('view').open();
                    this.isDetailPanelActive = true;
                }
                this.$mdSidenav('welcome').close();
                this.isWelcomeActive = false;
            }
        });

        $scope.$watch(() => {
            return util.getComputedStyle('view', 'display');
        }, () => {
            this.updateMapPosition();
        });

        element($window).on('resize', () => {
            this.updateMapPosition();
            if ($mdMedia('gt-sm')) {
                $mdBottomSheet.cancel();
            }
        });

        map.setCenterToInitialCenter();
    }

    // Methods
    $onInit() {
        const activityEl = element(document.getElementById('activity-indicator'));
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.$scope.$watch(() => {
            return this.$http.pendingRequests.length;
        }, (newLength, oldLength) => {
            if (newLength > 0) {
                activityEl.removeClass('invisible');
            } else {
                this.$timeout(function () {
                    activityEl.addClass('invisible');
                }, 500);
            }
        });
        const handleMotionPreference = (mq) => {
            if (mq.matches) {
                document.body.classList.add('reduce-motion');
            } else {
                document.body.classList.remove('reduce-motion');
            }
        };

        this.toggleFocusTrap();
        handleMotionPreference(mediaQuery);
        mediaQuery.addEventListener('change', handleMotionPreference);
    }

    isBusy() {
        return (
            this.searchService.searchInProgress ||
            this.fetchService.fetchInProgress
        );
    }

    isPanelOpen() {
        return (
            this.isWelcomeActive ||
            this.isLeftNavActive ||
            this.isFilterActive
        );
    }

    // Focus trap
    initFocusTrap() {
        if (this.focusTrap) {
            this.focusTrap.deactivate();
        }

        const sidebar = document.getElementById('toolbar-desktop') as HTMLElement | null;
        const activeElement = document.querySelector('.focus-panel.active') as HTMLElement | null;

        if (!sidebar || !activeElement) return;

        const elements = [sidebar, activeElement] as HTMLElement[];

        this.focusTrap = createFocusTrap(elements, {
            initialFocus: false,
            onDeactivate: () => {
                this.focusTrap = null;
            }
        });

        this.focusTrap.activate();
    }

    cleanupFocusTrap() {
        if (!this.focusTrap) return
        console.log('deactivate')
        this.focusTrap.deactivate();
        this.focusTrap = null;
    }
    toggleFocusTrap() {
        if (this.focusTrap) {
            this.cleanupFocusTrap();
        } else {
            this.$timeout(() => this.initFocusTrap(), 100);
        }
    }

    // Welcome panel controls
    openWelcomePanel() {
        this.toggleFocusTrap();
        this.$mdSidenav('welcome').open();
        this.isWelcomeActive = true;
        this.isLeftNavActive = false;
        this.isFilterActive = false;
    }

    closeWelcomePanel() {
        this.$mdSidenav('welcome').close();
        this.isWelcomeActive = false;
        this.cleanupFocusTrap()
    }

    toggleWelcomePanel() {
        this.$mdSidenav('welcome').toggle();
        this.isWelcomeActive = !this.isWelcomeActive;
        // this.toggleFocusTrap();

        if (this.isWelcomeActive) {
            this.isFilterActive = false;
            this.isLeftNavActive = false;
            this.$timeout(() => this.initFocusTrap(), 100);
        } else {
            this.cleanupFocusTrap();
        }
    }
    showHome() {
        this.closeLeftSidenav();
        this.closeAdvancedSearch();
        this.toggleWelcomePanel();
        this.isWelcomeActive = true;
        this.isLeftNavActive = false;
        this.isFilterActive = false;
    }

    // About Controls

    closeViewNav() {
        this.$mdSidenav('view').close();
    }

    openViewNav() {
        this.$mdSidenav('view').open();
    }

    openLeftSidenav() {
        this.$mdSidenav('sidenav-left').open().then(this.fixSidenavLinks.bind(this));
        this.closeAdvancedSearch();
        this.closeWelcomePanel();
        this.isWelcomeActive = false;
        this.isLeftNavActive = true;
        this.isFilterActive = false;
        if (!this.isKiosk) {
            this.isKiosk = !!document.getElementById('isKiosk-wayfinder');
        }
    }

    closeLeftSidenav() {
        this.$mdSidenav('sidenav-left').close();
        this.isLeftNavActive = false;
        this.cleanupFocusTrap()
    }

    toggleLeftSidenav() {
        this.$mdSidenav('sidenav-left').toggle();
        this.closeAdvancedSearch();
        this.closeWelcomePanel();
        this.isLeftNavActive = !this.isLeftNavActive;
        if (this.isLeftNavActive == true) {
            this.isWelcomeActive = false;
            this.isFilterActive = false;
            this.$timeout(() => this.initFocusTrap(), 100);
        }
        if (!this.isKiosk) {
            this.isKiosk = !!document.getElementById('isKiosk-wayfinder');
        }
    }

    showAbout() {
        const $mdDialog = this.$mdDialog;
        const $mdMedia = this.$mdMedia;
        const appConfig = this.appConfig;
        $mdDialog.show({
            template: aboutTemplate,
            fullscreen: $mdMedia('xs'),
            controllerAs: '$ctrl',
            controller: function () {
                this.hosts = appConfig.hosts;
                this.close = () => {
                    $mdDialog.hide();
                }
            }
        });
    }

    // Search Controls
    openAdvancedSearch() {
        this.$mdSidenav('advanced-search-filters').open();
        this.closeLeftSidenav();
        this.closeWelcomePanel();
        this.isWelcomeActive = false;
        this.isLeftNavActive = false;
        this.isFilterActive = true;
    }

    closeAdvancedSearch() {
        this.$mdSidenav('advanced-search-filters').close();
        this.isFilterActive = false;
        this.cleanupFocusTrap()
    }

    toggleAdvancedSearch() {
        this.$mdSidenav('advanced-search-filters').toggle();
        this.closeLeftSidenav();
        this.closeWelcomePanel();
        this.isFilterActive = !this.isFilterActive;
        if (this.isFilterActive == true) {
            this.isWelcomeActive = false;
            this.isLeftNavActive = false;
            this.$timeout(() => this.initFocusTrap(), 100);
        }
    }

    search() {
        this.searchService.currentPage = 1;
        if (this.searchService.hasFilters()) {
            let filters = this.searchService.getSearchFiltersFromProperties();
            this.$location.path('/search').search(filters);
            this.$route.reload();
        }
    }

    resetSearch() {
        this.reset({ zoomToExtent: false });
        this.$location.url('/');
    }

    reset(options: { zoomToExtent: boolean } = { zoomToExtent: true }) {
        const map = this.map;

        this.fetchService.reset();
        this.searchService.reset();

        this.$mdBottomSheet.cancel();
        this.closeAdvancedSearch();

        map.clearHighlightedFeatures();
        map.clearSelectedFeatures();
        if (options.zoomToExtent) {
            map.zoomToFullExtent();
            map.setCenterToInitialCenter();
        }
    }

    // Bottom Sheets 
    showInfoSheet() {
        const $mdBottomSheet = this.$mdBottomSheet;
        const map = this.map;

        this.$mdBottomSheet.show({
            template: infoSheetTemplate,
            controller: function () {
                this.map = map;
                this.switchLayer = (layer) => {
                    if (this.map.switchLayer(layer)) {
                        $mdBottomSheet.cancel();
                    }
                }
            },
            controllerAs: '$ctrl'
        });
    }

    showSearchResultsSheet() {
        const appController = this;
        const searchService = this.searchService;

        this.$mdBottomSheet.show({
            template: searchResultsSheetTemplate,
            controller: function () {
                this.articles = searchService.results;
                this.showArticle = (article) => {
                    appController.$location.url(article.path);
                    appController.$mdBottomSheet.cancel();
                }
            },
            controllerAs: '$ctrl'
        });
    }

    showArticleSheet(article) {
        this.$mdBottomSheet.show({
            locals: {
                article: article
            },
            template: articleSheetTemplate,
            controller: function () { },
            controllerAs: '$ctrl',
            bindToController: true
        });
    }

    // Helpers
    fixSidenavLinks() {
        // HACK: Clicking links in the sidenav doesn't close the sidenav
        //       by default.
        const links = document.querySelectorAll('md-sidenav a');
        Array.prototype.forEach.call(links, (link) => {
            link.addEventListener('click', this.closeLeftSidenav.bind(this), false);
        })
    }

    // Update left position of #map based on whether #view is displayed and its width. 
    updateMapPosition() {
        const map = this.map;
        const viewEl = document.getElementById('view');
        const viewElDisplayValue = util.getComputedStyle(viewEl, 'display');
        const viewNotDisplayed = !viewElDisplayValue || viewElDisplayValue === 'none';
        const mapEl = document.getElementById('map');
        const mapCurrentLeft = util.getComputedStyle(mapEl, 'left');
        const mapNewLeft = viewNotDisplayed ? '0px' : util.getComputedStyle(viewEl, 'width');
        if (mapNewLeft != mapCurrentLeft) {
            map.updateSize();
        }
    }
}


const AppComponent = {
    controller: AppController,
    template: appTemplate
}

export default AppComponent;
